import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { VideozapisiPopisService } from './videozapisi-popis.service';
import { VideoPopis } from './videozapisi-popis';
import { Subject } from 'rxjs';
import * as toastr from 'toastr';

@Component({
  selector: 'app-videozapisi-popis',
  templateUrl: './videozapisi-popis.component.html',
  styleUrls: ['./videozapisi-popis.component.css'],
  providers: [VideozapisiPopisService]
})
export class VideozapisiPopisComponent implements OnInit {

  sviVideozapisi: VideoPopis[] = [];
  videoOptions: DataTables.Settings = {};
  videoTrigger: Subject<VideoPopis> = new Subject();

  videozapisForma: FormGroup;
  videozapisEditForma: FormGroup;

  videoId: string;

  constructor(
    private _fb: FormBuilder,
    private _videozapisiPopisService: VideozapisiPopisService
  ) { }

  ngOnInit() {
     this.dohvati();
     //Tablica početak
     this.videoOptions = {
      pagingType: 'full_numbers',
      pageLength: 50,
      responsive: true,
      columnDefs: [{
          targets: 'no-sort',
          orderable: false
      }],
      retrieve: true
  };
  //Tablica kraj
    this.videozapisForma = this._fb.group({
      naziv: [''],
      link: [''],
    });
    this.videozapisEditForma = this._fb.group({
      naziv: [''],
      link: [''],
    });
  }

  pripremiPodatke(video){
    //console.log(video);
    this.videoId = video['id'];
    this.videozapisEditForma = this._fb.group({
      naziv: video['naziv'],
      link: video['link']
    });
  }

  uredi(video){
    //console.log(video);
    let podaciZaSlanje = {
      'idvideomaterijal': this.videoId,
      'naziv': video['naziv'],
      'sifra': video['link'],
      'access_token': localStorage.getItem('tokenSql')
    }
    //console.log(podaciZaSlanje);
    this._videozapisiPopisService.urediVideo(podaciZaSlanje).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        toastr.success("Uspješno uređivanje!");
        this.dohvati();
      } else {
        toastr.error("Neuspješno uređivanje!");
      }
    });
  }

  spremi(videozapisForma){
    //console.log(videozapisForma);
    if(videozapisForma['naziv'] && videozapisForma['link']){
      this._videozapisiPopisService.dodajVideo(videozapisForma).subscribe(res => {
        //console.log(res);
        if(res.success == true){
          toastr.success("Uspješno dodan video!");
          this.videozapisForma = this._fb.group({
            naziv: [''],
            link: ['']
          });
          this.dohvati();
        } else {
          toastr.error("Neuspješno spremanje!");
        }
      });
    } else {
      toastr.error("Unesite potrebne podatke!");
    }
  }

  dohvati(){
    this.sviVideozapisi = [];
    this._videozapisiPopisService.dohvatiSve({'idkorisnik': localStorage.getItem('userId')}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sviVideozapisi.push({
            'id': res.data[i]['idvideomaterijal'],
            'naziv': res.data[i]['vm_naziv'],
            'link': res.data[i]['vm_sifra']
          });
        }
        this.videoTrigger.next();
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/videozapisi-popis/videozapisi-popis.component.ts